const LoanPill = ({ loanType }) => {
  return (
    <div className="w-[100%] min-h-[39px] max-h-[40px] rounded-[30px] border-[0.5px] border-[#222222] bg-white text-[#222222] text-[14px] flex items-center justify-center">
      {loanType}
    </div>
  );
};

export default LoanPill;
